// extracted by mini-css-extract-plugin
module.exports = {"rightWrapper":"BannerContainer-module--rightWrapper--3Y8Fq","splitBg":"BannerContainer-module--splitBg--6ojFl"};